import { Box, Card, Container, Link, Stack, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useRentalsCustomerAuth } from 'src/auth/rentals-customer/rentals-customer-auth';

function ContactRow({ icon, children }: { icon: string; children: React.ReactNode }) {
  return (
    <Stack direction="row" gap={1.5} alignItems="center">
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'grey.200',
          color: 'text.secondary',
          flexShrink: 0,
        }}
      >
        <Iconify icon={icon} width={18} />
      </Box>
      {children}
    </Stack>
  );
}

export default function Page() {
  const { session } = useRentalsCustomerAuth();
  const settings = session?.organizationSettings;

  if (!settings) {
    return null;
  }

  const addressParts = [
    settings.companyAddress?.street1,
    settings.companyAddress?.street2,
    settings.companyAddress?.city,
    settings.companyAddress?.state,
    settings.companyAddress?.zip,
  ].filter(Boolean);

  return (
    <Container maxWidth="lg">
      <Stack gap={2}>
      <Typography variant="h4">Contact</Typography>

      <Card sx={{ p: 3, maxWidth: 520 }}>
        <Stack gap={2.5}>
          <Stack direction="column" gap={2} alignItems="start">
            {settings.companyLogoUrl && (
              <Box component="img" src={settings.companyLogoUrl} sx={{ height: 48, borderRadius: 1 }} />
            )}
            <Box>
              <Typography variant="h6">{settings.companyName}</Typography>
              <Typography variant="body2" color="text.secondary">
                Questions about your rental? Get in touch.
              </Typography>
            </Box>
          </Stack>

          <Stack gap={1.5}>
            {addressParts.length > 0 && (
              <ContactRow icon="mingcute:location-fill">
                <Typography variant="body2">{addressParts.join(', ')}</Typography>
              </ContactRow>
            )}

            {settings.contactPhone && (
              <ContactRow icon="solar:phone-bold">
                <Link href={`tel:${settings.contactPhone}`} variant="body2" color="text.primary">
                  {settings.contactPhone}
                </Link>
              </ContactRow>
            )}

            {settings.contactEmail && (
              <ContactRow icon="ic:round-email">
                <Link href={`mailto:${settings.contactEmail}`} variant="body2" color="text.primary">
                  {settings.contactEmail}
                </Link>
              </ContactRow>
            )}
          </Stack>
        </Stack>
      </Card>
      </Stack>
    </Container>
  );
}
